// Brand Configuration — White-label ready
// To rebrand for another agent/brokerage, only change this file.

export const BRAND = {
  // App Identity
  appName: 'PropertyPath',
  appNameStyled: { first: 'Property', accent: 'Path' }, // first + colored accent
  tagline: 'YOUR REAL ESTATE INVESTMENT ADVISOR',
  subtitle: 'by Vacation Home Group',
  description: 'Model hold, sell, and 1031 exchange scenarios with AI-powered analysis.',

  // Company
  company: 'Vacation Home Group',
  brokerage: 'Real Broker NH, LLC',
  brokerageDisclaimer: '',
  website: 'https://www.vacationhomegroup.net',
  websiteDisplay: 'vacationhomegroup.net',
  domain: 'vacationhome.group',
  phone: '855-450-0442',
  motto: 'Your Retreat, Our Expertise',

  // Agents
  agents: [
    { name: 'Joe Mori', title: 'REALTOR® · Vacation Home Specialist', phone: '603-901-7777', email: 'joemori@vacationhome.group' },
  ],

  // Colors (VHG Brand Guide v4.1)
  colors: {
    green: '#167A5E',     // Primary actions, accent
    greenLight: '#10B981', // Mountain ridgeline, highlights
    gold: '#9A7820',      // Premium, labels, gold elements
    goldHorizon: '#C8962E', // Horizon line
    darkBg: '#0B1120',    // Dark theme background
    lightBg: '#FFFFFF',   // Light theme background
  },

  // Pro Features
  proFeatures: 'Tax Benefits · Mortgage · What-If · AI Summary · Save & Compare · PDF · Email Results',
  proPrice: 'Free — just verify your email',

  // Related Apps (for AI cross-promotion and emails)
  apps: [
    { name: 'STRcalc', url: 'https://strcalc.redeapps.com', desc: '3-scenario purchase analyzer (worst/likely/best) with deal signal scoring, cleaning economics, PM suite, and PDF export. For evaluating new STR purchases.' },
    { name: 'SellerCalc', url: 'https://sellercalc.redeapps.com', desc: 'Home sale calculator with net proceeds breakdown, post-sale options (Buy/Rent/Invest), what-if scenarios, and 30-year projections. For homeowners thinking about selling.' },
    { name: 'RentOrOwn', url: 'https://rentorown.redeapps.com', desc: 'Rent vs Own comparison with total cost of ownership, equity building, tax benefits, and break-even analysis. For people deciding whether to buy or rent.' },
  ],

  // Email
  fromEmail: 'PropertyPath <noreply@vacationhomegroup.net>',
  defaultNotifyEmails: ['joemori@vacationhome.group'],

  // Disclaimers
  disclaimer: 'This tool does not constitute financial, tax, or investment advice. Projections are estimates based on user-provided inputs. Consult a qualified real estate professional, CPA, or financial advisor before making investment decisions. This tool is provided on an as-is basis, without warranties of any kind, and to the fullest extent permitted by law neither the provider nor the REDE platform is liable for any loss arising from its use or reliance on its output. Use of this tool creates no agency, brokerage, fiduciary, or client relationship.',
  liabilityDisclaimer: 'Vacation Home Group, its agents, and this platform assume no liability for decisions made based on this analysis.',
  emailConsent: 'By using this platform, you consent to the collection of your email address and preferences for the purpose of delivering personalized market analysis. We do not sell or share your information with third parties.',
};

export default BRAND;
